import {validators} from 'vue-form-generator';
import {invalidPhoneNumber} from './customValidations';
import {setCustomValidationProperties} from '../customValidationHelpers';
import store from '../../../../vue/store/store';

let storeValues = store

const changeFunction = (storeValues, currentVal) => {
    if (storeValues.getters['checkout/smallFleetOpportunity'] || (storeValues.getters['billing/email'] === currentVal.email || storeValues.getters['billing/email'] === '')) {
        document.getElementsByClassName('additional-email').length > 0 && (document.getElementsByClassName('additional-email')[0].style.display = 'none');
    } else {
        document.getElementsByClassName('additional-email').length > 0 && (document.getElementsByClassName('additional-email')[0].style.display = 'flex');
    }
}

export const email = {
    type: 'input',
    inputType: 'text',
    label: '',
    id: 'email',
    model: 'email',
    required: true,
    disabled: false,
    styleClasses: "col xs-12 md-6",
    onChanged: (newVal) => changeFunction(storeValues, newVal),
    validator: [validators.email],
}

export const additionalEmail = {
    type: 'checkbox',
    inputType: 'checkbox',
    label: '',
    id: 'additional-email',
    model: 'additionalEmail',
    required: false,
    disabled: false,
    styleClasses: "col xs-12 md-6 additional-email",
    validator: [],
}


export const phone = {
    type: 'input',
    inputType: 'text',
    label: '',
    id: 'phone',
    model: 'phone',
    required: true,
    disabled: false,
    styleClasses: "col xs-12 md-6",
    validator: [
        validators.string,
        setCustomValidationProperties(invalidPhoneNumber, "invalidPhoneNumber")
    ],
}
